import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";
import {
	CheckBox,
	ColorPicker,
	NumberInput,
	BorderStylePicker,
	GradientInput,
	ShadowInput,
} from "../../../../../components/shared/Forms";
import { Font } from ".";

const Controls = ({ themeData, scopePicked, primaryState, checkForEmptyValues }) => {
	const currentElementType = themeData.controls[scopePicked];
	const states = Object.keys(currentElementType);
	return (
		<div className="theme-columns">
			{states.map(state => {
				const primaryStatePath = `controls.${scopePicked}.${primaryState}`;
				const currentStatePath = `controls.${scopePicked}.${state}`;
				return (
					<Scope scope={state} key={state}>
						<div className="theme-column">
							<h4 className="header">{state}</h4>
							<div className="theme-content">
								<Scope scope="font">
									<Font
										state={state}
										checkForEmptyValues={checkForEmptyValues}
										primaryStatePath={primaryStatePath}
										currentStatePath={currentStatePath}
									/>
								</Scope>
								{checkForEmptyValues(primaryStatePath, currentStatePath, [
									<BorderStylePicker
										field="borderStyle"
										id="borderStyle"
										placeholder="Border Styles"
										themeBuilderInputType="BorderStylePicker"
									/>,
									<ColorPicker
										field="borderColor"
										id="borderColor"
										placeholder="Border Color"
										themeBuilderInputType="ColorPicker"
									/>,
									<NumberInput
										field="borderWidth"
										id="borderWidth"
										placeholder="Border Width"
										themeBuilderInputType="NumberInput"
									/>,
									<NumberInput
										field="borderRadius"
										id="borderRadius"
										placeholder="Border Radius"
										max={768}
										themeBuilderInputType="NumberInput"
									/>,
									<CheckBox
										field="borderTopOn"
										id={`${state}-borderTopOn`}
										label="Border Top"
										textalign="center"
										themeBuilderInputType="CheckBox"
									/>,
									<CheckBox
										field="borderLeftOn"
										id={`${state}-borderLeftOn`}
										label="Border Left"
										textalign="center"
										themeBuilderInputType="CheckBox"
									/>,
									<CheckBox
										field="borderRightOn"
										id={`${state}-borderRightOn`}
										label="Border Right"
										textalign="center"
										themeBuilderInputType="CheckBox"
									/>,
									<CheckBox
										field="borderBottomOn"
										id={`${state}-borderBottomOn`}
										label="Border Bottom"
										textalign="center"
										themeBuilderInputType="CheckBox"
									/>,
									<NumberInput
										field="paddingVertical"
										id="paddingVertical"
										placeholder="Vertical Padding"
										themeBuilderInputType="NumberInput"
									/>,
									<NumberInput
										field="paddingHorizontal"
										id="paddingHorizontal"
										placeholder="Horizontal Padding"
										themeBuilderInputType="NumberInput"
									/>,
									<ColorPicker
										field="backgroundColor"
										id="backgroundColor"
										placeholder="Background Color"
										themeBuilderInputType="ColorPicker"
									/>,
									<GradientInput
										field="backgroundGradient"
										id="backgroundGradient"
										placeholder="Background Gradient"
										themeBuilderInputType="GradientInput"
									/>,
									<ShadowInput
										field="boxShadow"
										id="boxShadow"
										placeholder="Box Shadow"
										themeBuilderInputType="ShadowInput"
									/>,
								])}
							</div>
						</div>
					</Scope>
				);
			})}
		</div>
	);
};

Controls.propTypes = {
	checkForEmptyValue: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	scopePicked: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Controls;
